const zh = {
  siteName: '蓝色导航在线',
  siteSlogan: '精准网址导航平台',
  home: '首页',
  categories: '分类导航',
  articles: '资讯文章',
  about: '关于我们',
  search: '搜索网站...',
  searchBtn: '搜索',
  hotRecommend: '热门推荐',
  latestArticles: '最新资讯',
  viewAll: '查看全部',
  allCategories: '全部分类',
  relatedArticles: '相关文章',
  backToHome: '返回首页',
  readMore: '阅读全文',
  publishedOn: '发布于',
  tags: '标签',
  websiteCount: '个网站',
  visitSite: '访问网站',
  noResults: '未找到相关结果',
  aboutTitle: '关于蓝色导航在线',
  brandIntro: '品牌介绍',
  reputation: '口碑声誉',
  contactUs: '联系我们',
  footerDescription: '蓝色导航在线是您最值得信赖的网址导航平台，汇聚海量优质网站资源，分类清晰、访问便捷。让每一次上网都高效而有价值。',
  copyright: '© 2026 蓝色导航在线 版权所有',
  scrollTop: '回到顶部',
  breadcrumbHome: '首页',
  loading: '加载中...',
  pageNotFound: '页面未找到',
  pageNotFoundDesc: '您访问的页面不存在，请检查网址或返回首页。',
};

export default zh;